import { ScrollContainer } from 'foundations-components/transitional/components/ScrollContainer';
import { styled, useTheme } from '../lib/styles';
import { jsx as _jsx } from "react/jsx-runtime";
export const AllDayEvent = styled.div.withConfig({
  displayName: "AllDayEvents__AllDayEvent",
  componentId: "sc-1qwqf64-0"
})(({
  dayOfWeek = 0,
  index,
  length = 1,
  theme
}) => `
  overflow: hidden;
  padding: 0 ${theme.space[25]};
  grid-column: ${Math.max(dayOfWeek, 0) + 1} / span ${length};
  grid-row: ${index ? index + 1 : 'auto'};
  height: fit-content;
`);
export const AllDayEventsGrid = styled.div.withConfig({
  displayName: "AllDayEvents__AllDayEventsGrid",
  componentId: "sc-1qwqf64-1"
})(({
  theme
}) => `
  flex: 1 1 auto;
  display: grid;
  grid-template-columns: repeat(
    ${theme.uiAddonCalendars.allDayEvents.numberOfColumns},
    1fr
  );
  row-gap: ${theme.space[100]};
`);
export const AllDayEventsContainer = ({
  children
}) => {
  const {
    uiAddonCalendars: {
      allDayEvents: {
        maxHeight,
        minHeight
      }
    }
  } = useTheme();
  return /*#__PURE__*/_jsx(ScrollContainer, {
    position: "relative",
    inlineSize: "100%",
    maxBlockSize: maxHeight,
    minBlockSize: minHeight,
    paddingBlock: "100",
    children: /*#__PURE__*/_jsx(AllDayEventsGrid, {
      children: children
    })
  });
};